import React from 'react'
import { connect, useSelector } from 'react-redux'
import { selectUser } from 'UserApp/store/user/selectors'
import { Redirect } from 'react-router-dom'
import OrderIntellitagModal from 'UserApp/components/OrderIntellitagModal'

function OrderIntellitagModalContainer(props) {

  const user = useSelector(selectUser)
  const { hasSubscription, status } = user

  /**
   * If someone directly hit the url then also check weather the user has subscription or not
   * If not then redirect to upgrade page
   */
  if (!hasSubscription) {
    return <Redirect to='/settings/upgrade' />
  }

  function handleClose() {
    props.history.push('/')
  }

  return <OrderIntellitagModal {...props} onClose={handleClose} />
}

export default connect((state) => ({
  orderId: state.intellitagOrder.id,
}))(OrderIntellitagModalContainer)
